module.exports = __webpack_public_path__ + "static/KatieSchad-42043dba9f1e59c93d7cfa6dae7c297f.jpg";